module.exports = __webpack_public_path__ + "static/media/3DPPA10.e10ce422.jpg";